import { FleekError } from './FleekError';

type Invitation = {
  id?: string;
  hash?: string;
};

type InvitationNotFoundErrorOptions = {
  invitation: Invitation;
};

export class InvitationNotFoundError extends FleekError<InvitationNotFoundErrorOptions> {
  public name = 'InvitationNotFoundError';

  toString = () => {
    return 'Invitation was not found.';
  };
}
